module.exports = __webpack_public_path__ + "img/knitting.dcf85a52.svg";